import TestimonyRepositories from "@repositories/testimony.repositories"
import { Result } from "@lib/api/services/result"
import { Testimony } from "@interfaces/testimony"

export default class FaqServices extends TestimonyRepositories {
  async getTestimonyList() {
    try {
      const res = await this.getRawTestimonyList()

      const { error, result } = await this._getResponse<Testimony[]>(res)
      
      if (error || !result) {
        return Result.fail<Testimony[]>()
      }

      const testimonies = result.map((p) => {
        return this._swaggerResponseSpreader<any>(p)
      })

      return Result.ok<Testimony[]>(testimonies)
    } catch (e) {
      return Result.fail<Testimony[]>()
    }
  }
}
